import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const TOKEN_KEY = 'hengye_token'

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem(TOKEN_KEY) || ''
  },
  getters: {
    isLogin: state => !!state.token
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      if (token) {
        sessionStorage.setItem(TOKEN_KEY, token)
      } else {
        sessionStorage.removeItem(TOKEN_KEY)
      }
    }
  },
  actions: {
    logout ({ commit }) {
      commit('setToken', '')
    }
  },
  modules: {
  }
})
